import { defineStore } from "pinia";
import soundMusic from "@/assets/sounds/music.mp3";
import soundBuzzer from "@/assets/sounds/buzzer.mp3";
import soundTap from "@/assets/sounds/tap.mp3";

export const useGlobalStore = defineStore({
  id: "global",
  state: () => ({
    currentStep: "peopleCheck",
    ageCheckConfirmed: false,
    legalConditionsAccepted: false,
    legalConditionsReturnStep: "ageCheck",
    timesLeftToPlay: 2,
    shouldShowDailyLimitScreen: false,
    remainingDailyPlays: null as number | null,
    capturedPhotoFile: null as File | null,
    capturedPhotoDataUrl: null as string | null,
    uploadedPhotoItemId: null as number | null,
    raffleResult: null as "win" | "lose" | null,
    totalPlays: 0,
    session: null as null | unknown,
    country: null as null | unknown,
    sounds: {
      backgroundMusic: new Audio(soundMusic),
      buzzerSound: new Audio(soundBuzzer),
      tapSound: new Audio(soundTap),
    },
  }),
  actions: {
    changeStep(step: string) {
      this.currentStep = step;
    },
    openTermsAndConditions(returnStep = "ageCheck") {
      this.legalConditionsReturnStep = returnStep;
      this.currentStep = "termsAndConditions";
    },
    confirmAgeCheck(value: boolean) {
      this.ageCheckConfirmed = value;
    },
    acceptLegalConditions(value: boolean) {
      this.legalConditionsAccepted = value;
    },
    setTimesLeftToPlay(times: number) {
      this.timesLeftToPlay = times;
    },
    setShouldShowDailyLimitScreen(value: boolean) {
      this.shouldShowDailyLimitScreen = value;
    },
    setRemainingDailyPlays(value: number | null) {
      this.remainingDailyPlays = value;
    },
    setCapturedPhotoFile(value: File | null) {
      this.capturedPhotoFile = value;
    },
    setCapturedPhotoDataUrl(value: string | null) {
      this.capturedPhotoDataUrl = value;
    },
    setUploadedPhotoItemId(value: number | null) {
      this.uploadedPhotoItemId = value;
    },
    setRaffleResult(value: "win" | "lose" | null) {
      this.raffleResult = value;
    },
    resetGame(selectedPerson = 1) {
      this.timesLeftToPlay = selectedPerson * 2;
    },
    playBackgroundMusic() {
      this.sounds.backgroundMusic.loop = true;
      this.sounds.backgroundMusic.play();
    },
    pauseBackgroundMusic() {
      this.sounds.backgroundMusic.pause();
    },
    playBuzzerSound() {
      const buzzerSound = new Audio(soundBuzzer);
      buzzerSound.play();
    },
    playTapSound() {
      const tapSound = new Audio(soundTap);
      tapSound.play();
    },
    setSession(session: unknown) {
      this.session = session;
    },
    setCountry(country: unknown) {
      this.country = country;
    },
  },
});
